module.exports = __webpack_public_path__ + "images/content-electronics.e715a83e9ac7a9a0dae906dd93964574.svg";